import { S3Onboarding } from 'components/onboarding/S3Onboarding';

const OnboardingPage = () => {
  return <S3Onboarding isOpen setIsOpen={() => {}} />;
};
export default OnboardingPage;
